






































import { Component, Mixins } from 'vue-property-decorator'
import { Action } from 'vuex-class'

// Helpers
import { Meta } from '@/helpers/decorators'

// Mixins
import Logo from '@/mixins/Logo'
import Errors from '@/mixins/Errors'

// Components
import Box from '@/components/common/Box.vue'
import InfoBox from '@/components/common/InfoBox.vue'
import LogoUploader from '@/components/images/LogoUploader.vue'
import ImageViewer from '@/components/common/ImageViewer.vue'

@Component({
  components: {
    Box,
    InfoBox,
    LogoUploader,
    ImageViewer
  }
})
export default class LogoCompany extends Mixins(Logo, Errors) {
  logoLoading: boolean = false
  reloadLogo: boolean = false

  @Action('updateCompanyLogoId', { namespace: 'user' }) updateCompanyLogoId

  @Meta
  metas() {
    return {
      title: this.$t('company.menu.logo'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }

  async submitAvatar(base64) {
    try {
      this.logoLoading = true
      console.log(base64)
      const res = await this.updateCompanyLogoId(base64)
      this.reloadLogo = true
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.logoLoading = false
      setTimeout(() => {
        this.reloadLogo = false
      }, 300)
    }
  }
}
